import { Star } from "lucide-react";
import { cn } from "@/lib/cn";

interface Props {
  /** Average rating 0–5 (may be fractional). */
  value: number;
  /** Icon size in pixels. */
  size?: number;
  className?: string;
}

/**
 * Read-only 5-star rating display (TASK-3733). Renders five star outlines and
 * fills `Math.round(value)` of them. Used by the driver scorecard and the
 * ratings summary; not interactive.
 */
export function RatingStars({ value, size = 14, className }: Props) {
  const filled = Math.round(value);
  return (
    <span
      className={cn("inline-flex items-center gap-0.5", className)}
      aria-hidden="true"
    >
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          size={size}
          className={
            i < filled
              ? "fill-amber-400 text-amber-400"
              : "fill-gray-200 text-gray-200"
          }
        />
      ))}
    </span>
  );
}
